import {
    FETCH_DEMO_FEEDBACK_QUESTIONS,
    TOGGLE_IS_FETCHING_FEEDBACK_QUESTIONS,
    SAVE_FEEDBACK_QUESTIONS_ROLE_TEMPLATES,
    UPDATE_FEEDBACK_QUESTIONS_ROLE_TEMPLATE,
    GET_SELECTED_FEEDBACK_QUESTION,
    CLEAR_FEEDBACK_QUESTIONS_FORM,
    CANCEL_FEEDBACK_QUESTIONS_ROLE_TEMPLATES,
    CLEAR_FEEDBACK_QUESTIONS,
    LAST_FEEDBACK_QUESTIONS_FILTER,
    FETCH_FEEDBACK_QUESTION_DETAILS,
    REFRESH_FEEDBACK_QUESTIONS,
    UPDATE_FEEDBACK_QUESTIONS_FORM_TAB_DATA
} from "../actions/types";

import CONFIG from "../config";

const feedbackQuestionsState = {
    isFetching: false,
    currentPageNumber: undefined,
};



export const feedbackQuestionsReducer = (state = feedbackQuestionsState, action) => {
    switch (action.type) {
        case FETCH_DEMO_FEEDBACK_QUESTIONS:
            return { ...state, questions: action.payload };
        case TOGGLE_IS_FETCHING_FEEDBACK_QUESTIONS:
            return { ...state, isFetching: action.payload };
        case LAST_FEEDBACK_QUESTIONS_FILTER:
            return { ...state, currentFilter: action.payload[0], status: action.payload[1], isEdit: true, currentPageNumber: action.payload[2] }
        case CLEAR_FEEDBACK_QUESTIONS:
            return feedbackQuestionsState;
        case REFRESH_FEEDBACK_QUESTIONS:
            return { ...state, data: [], count: undefined };
        default:
            return state;
    }
};

const feedbackQuestionsFormState = {
    allRoleTemplatesUserAccess: undefined,
    allRoleTemplatesAdminAccess: undefined,
    feedbackQuestionFormData: [],
    tabData: []
};


export const feedbackQuestionsFormReducer = (state = feedbackQuestionsFormState, action) => {
    switch (action.type) {
        case FETCH_FEEDBACK_QUESTION_DETAILS:
            return {
                ...state,
                ...action.payload,
                assignedRoleTemplates: action.payload.roleTemplates || [],
                feedBackQuestionObj: action.payload
            };
        case UPDATE_FEEDBACK_QUESTIONS_FORM_TAB_DATA:
            return {
                ...state,
                tabData: state.tabData.filter(obj => ((parseInt(obj?.id) !== parseInt(action.payload?.id)))).concat(action.payload)
            }
        case SAVE_FEEDBACK_QUESTIONS_ROLE_TEMPLATES:
            const updatedRTSaveData = state.tabData?.map(el => ((parseInt(el?.id) === parseInt(action.payload?.id)))
                ? {
                    ...el, data: {
                        ...el.data,
                        assignedRoleTemplates: el.data.roleTemplates
                    }
                } : el)
            return { ...state, tabData: updatedRTSaveData };
        case TOGGLE_IS_FETCHING_FEEDBACK_QUESTIONS:
            return { ...state, isFetching: action.payload };
        case UPDATE_FEEDBACK_QUESTIONS_ROLE_TEMPLATE:
            const updatedData = state.tabData?.map(el => ((parseInt(el?.id) === parseInt(action.payload?.questionId)))
                ? {
                    ...el,
                    data: {
                        ...el.data,
                        roleTemplates: action.payload.updatedRoleTemplates,
                        [action.payload.accessKey]: !action.payload.selectedRoleTemplate && action.payload.access
                            ? action.payload.accessType
                            : CONFIG.roleTemplateAccess.none
                    }
                }
                : el)
            return {
                ...state, tabData: updatedData,
            }
        case GET_SELECTED_FEEDBACK_QUESTION:
            return {
                ...state,
                ...action.payload,
                assignedRoleTemplates: action.payload.roleTemplates || [],
            };
        case CLEAR_FEEDBACK_QUESTIONS_FORM:
            const updatedTabQuestionsData = state.tabData?.filter(el => ((parseInt(el?.id) !== parseInt(action.payload?.id))));
            return { ...state, tabData: updatedTabQuestionsData };
        case CANCEL_FEEDBACK_QUESTIONS_ROLE_TEMPLATES:
            const updatedRTCancelData = state.tabData?.map(el =>
                ((parseInt(el?.id) === parseInt(action.payload?.id)))
                    ? {
                        ...el, data: {
                            ...el.data,
                            roleTemplates: el.data.assignedRoleTemplates,
                            allRoleTemplatesUserAccess: undefined,
                            allRoleTemplatesAdminAccess: undefined
                        }
                    } : el)
            return { ...state, tabData: updatedRTCancelData };
        default:
            return state;
    }
};
